/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable no-nested-ternary */ /* eslint-disable camelcase */ /* eslint-disable no-unused-vars */ /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable react/prop-types */ /* eslint-disable no-param-reassign */ import React, {
  useState,
  useContext,
} from 'react';
import { useTranslation } from 'react-i18next';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import moment from 'moment-timezone';

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { formatCurrency } from '../../../service/utils';
import Cancel from '../modals/Cancel';
import UpdateStatus from '../modals/UpdateStatus';
import EditCostCenter from '../modals/EditCostCenter';
import api from '../../../service/axios/api';
import FlashContext from '../../../components/contexts/FlashContext';
import Status from '../../../service/translateStatus';

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
  table: {
    minWidth: 1100,
  },
});

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: '#303474',
    color: 'white',
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

// eslint-disable-next-line import/prefer-default-export
export function ReceivablesTableRow({ docs, searchData }) {
  const { t } = useTranslation();
  const { notifyError, notifySuccess } = useContext(FlashContext);
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);

  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);

  const [loadingEditCostCenter, setLoadingEditCostCenter] = useState(false);
  const [openEditCostCenter, setOpenEditCostCenter] = useState(false);
  const [costCenter, setCostCenter] = useState(0);

  const [loadingCancel, setLoadingCancel] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);

  const handleMenu = event => {
    if (docs.status !== 'Cancelada') setAnchorEl(event.currentTarget);
  };

  const handleCancel = async () => {
    setLoadingCancel(true);
    try {
      const { data } = await api.receivables.update(docs.id, 'Cancelada', null);
      notifySuccess(data.message);
      setOpenCancel(false);
      searchData();
    } catch (error) {
      if (error.problems && error.problems.length > 0) {
        error.problems.forEach(err => {
          notifyError(err.msg);
        });
      } else {
        notifyError(error.message);
      }
    } finally {
      setLoadingCancel(false);
      setAnchorEl(null);
    }
  };

  const handleEditCostCenter = async () => {
    setLoadingEditCostCenter(true);
    try {
      const { data } = await api.receivables.update(
        docs.id,
        undefined,
        costCenter,
      );
      notifySuccess(data.message);
      setOpenCancel(false);
      searchData();
    } catch (error) {
      if (error.problems && error.problems.length > 0) {
        error.problems.forEach(err => {
          notifyError(err.msg);
        });
      } else {
        notifyError(error.message);
      }
    } finally {
      setLoadingEditCostCenter(false);
      setOpenEditCostCenter(false);
      setAnchorEl(null);
    }
  };

  const handleUpdate = async () => {
    setLoadingUpdate(true);
    try {
      const { data } = await api.receivables.update(docs.id, 'Pago', null);
      notifySuccess(data.message);
      setOpenUpdate(false);
      searchData();
    } catch (error) {
      if (error.problems && error.problems.length > 0) {
        error.problems.forEach(err => {
          notifyError(err.msg);
        });
      } else {
        notifyError(error.message);
      }
    } finally {
      setLoadingUpdate(false);
      setAnchorEl(null);
    }
  };

  return (
    <>
      <StyledTableRow key={docs.id}>
        <StyledTableCell>{docs.client_name || '-'}</StyledTableCell>
        <StyledTableCell>{docs.client_doc || '-'}</StyledTableCell>
        <StyledTableCell>{docs.cost_center_name || '-'}</StyledTableCell>
        <StyledTableCell>{docs.order_number || '-'}</StyledTableCell>
        <StyledTableCell>{Status(docs.description, t) || '-'}</StyledTableCell>
        <StyledTableCell>
          {docs.due_date && moment(docs.due_date).format('DD/MM/YYYY')}
        </StyledTableCell>
        <StyledTableCell>{formatCurrency(docs.amount || 0)}</StyledTableCell>
        <StyledTableCell>{docs.status || '-'}</StyledTableCell>
        <StyledTableCell
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {docs.created_at && moment(docs.created_at).format('DD/MM/YYYY')}
          {docs.status === 'Pendente' && (
            <MoreVertIcon
              onClick={e => handleMenu(e)}
              fontSize="small"
              style={{ cursor: 'pointer' }}
            />
          )}
        </StyledTableCell>
      </StyledTableRow>
      <Menu
        id="menu-appbar"
        style={{ borderRadius: '25px' }}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          className={classes.textNotification}
          onClick={() => setOpenEditCostCenter(true)}
        >
          {t('receivables.table.menu.editCostCenter')}
        </MenuItem>
        <MenuItem
          className={classes.textNotification}
          onClick={() => setOpenUpdate(true)}
        >
          {t('receivables.table.menu.confirmPayment')}
        </MenuItem>
        <MenuItem
          className={classes.textNotification}
          onClick={() => setOpenCancel(true)}
        >
          {t('receivables.table.menu.cancel')}
        </MenuItem>
      </Menu>
      <Cancel
        openCancel={openCancel}
        setOpenCancel={setOpenCancel}
        loadingCancel={loadingCancel}
        handleCancel={handleCancel}
      />
      <EditCostCenter
        openEdit={openEditCostCenter}
        setOpenEdit={setOpenEditCostCenter}
        loadingEdit={loadingEditCostCenter}
        handleEdit={handleEditCostCenter}
        costCenter={costCenter}
        setCostCenter={setCostCenter}
      />
      <UpdateStatus
        openUpdate={openUpdate}
        setOpenUpdate={setOpenUpdate}
        loadingUpdate={loadingUpdate}
        handleUpdate={handleUpdate}
      />
    </>
  );
}
